// Compare code structure only. This is not a classification verdict.
export function hskDifference(values) {
  const codes = [...new Set((values || []).map(v => String(v ?? "").replace(/[.\-\s]/g, "")).filter(v => /^\d{10}$/.test(v)))];
  if (codes.length < 2) return null;
  for (const [length, level, label] of [[2, "chapter", "류·호 상이"], [4, "heading", "호 상이"], [6, "subheading", "소호 상이"], [10, "national", "국내 세분 상이"]]) {
    const prefixes = [...new Set(codes.map(v => v.slice(0, length)))];
    if (prefixes.length > 1) return { length, level, label, prefixes };
  }
  return null;
}
